// warehouse/getAll

import api from "./api-configuration";

export const getAllWarehouses = async (transferDepo = false) => {
    return await api.post(`/warehouse/getAll`)
        .then(res => {
            let all_data = res.data || [];
            all_data = all_data.filter(x => (
                x.is_active === true &&
                x.id !== 18 &&
                x.id !== 19 &&
                x.id !== 28 &&
                x.id !== 29 &&
                x.id !== 33
            ));
            if (transferDepo === false) {
                all_data = all_data.filter(x => x.id !== 34);
            }
            return all_data;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
}
export const getZoneByWarehouseId = async (warehouse_id) => {
    return await api.post(`/zone/getZonesByWarehouse`, { warehouse_id })
        .then(res => {
            let all_data = res.data.data || [];
            return all_data.filter(x => x.is_active === true && x.zone_name !== "SANAL" && x.zone_type !== "TYPE_RECEPTION");
        })
        .catch(err => {
            console.error(err);
            return err;
        });
}
export const getAllBolge = async () => {

    // /zone/getAll

    return await api.post(`/zone/getAll`)
        .then(res => {
            let all_data = res.data.data || [];
            return all_data.filter(x => x.is_active === true && x.zone_type !== "TYPE_RECEPTION" && x.zone_type !== "TYPE_SHIPPING" && x.zone_name !== "SANAL"
                && x.warehouse_id !== 18 && x.warehouse_id !== 19 && x.warehouse_id !== 28 && x.warehouse_id !== 29
            );
        })
        .catch(err => {
            console.error(err);
            return err;
        });
}

export const getTotalStockOfEachWarehouse = async () => {
    return await api.post(`/getTotalStockOfEachWarehouse`)
        .then(res => {
            return res.data || [];
        })
        .catch(err => {
            console.error(err);
            return err;
        });
}

export const getTotalStockWithInvoicedOrShippingOrders = async () => {
    return await api.post(`/getTotalStockWithInvoicedOrShippingOrders`)
        .then(res => {
            return res.data || "-";
        })
        .catch(err => {
            console.error(err);
            return "-";
        });
}

export const getWarehouseAndDealerExitReport = async (start_date, end_date) => {
    return await api.post(`/getWarehouseAndDealerExitReport`, { start_date, end_date })
        .then(res => {
            return res.data || [];
        })
        .catch(err => {
            console.error(err);
            return [];
        });
}

export const getBlockedVehicles = async () => {
    return await api.post(`/getBlockedVehicles`)
        .then(res => {
            return res.data || "0";
        })
        .catch(err => {
            console.error(err);
            return "0";
        });
}

export const getAllShippableVehicles = async () => {
    return await api.post(`/getAllShippableVehicles`)
        .then(res => {
            return res.data || "0";
        })
        .catch(err => {
            console.error(err);
            return "0";
        });
}
